import React from "react";
import DOMPurify from "dompurify";

// Allowed tags/attrs are intentionally narrow — what TipTap RichEditor can produce.
const SANITIZE_CONFIG = {
  ALLOWED_TAGS: ["p", "br", "strong", "em", "u", "s", "a", "ul", "ol", "li", "span"],
  ALLOWED_ATTR: ["href", "target", "rel", "style"],
  ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
};

export function sanitize(html) {
  if (!html) return "";
  return DOMPurify.sanitize(String(html), SANITIZE_CONFIG);
}

export function isHtml(s) {
  return typeof s === "string" && /<\/?[a-z][\s\S]*>/i.test(s);
}

// Strip tags to plain text (used for piping fallbacks where HTML doesn't make sense)
export function stripHtml(html) {
  if (!html) return "";
  if (!isHtml(html)) return String(html);
  const tmp = document.createElement("div");
  tmp.innerHTML = sanitize(html);
  return tmp.textContent || tmp.innerText || "";
}

// Inline = strip wrapping <p> so it flows on a single line (used for question titles)
export function RichText({ html, className = "", inline = false, as: Tag = "span" }) {
  if (!html) return null;
  let safe = sanitize(html);
  if (inline) {
    // unwrap a single root <p>
    safe = safe.replace(/^<p>([\s\S]*)<\/p>$/i, "$1");
  }
  return <Tag className={`rt-render ${className}`} dangerouslySetInnerHTML={{ __html: safe }} />;
}

export default RichText;
